import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { BookingStepComponent } from './booking-step.component';
import { StepResolverService } from '../../../services';

export const bookingStepRoute: Route = {
  path: RouteIds.booking,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.booking) },
  component: BookingStepComponent,
};
